import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GECKO_CONSTS, GeckoCard, GeckoBtns } from 'ui';
import { renderError } from 'services/gecko-error';
import GeckoLocation from 'services/gecko-location';
import CONSTS from 'constants/index.js';
import DeltaSummaryProgress from '../DeltaSummaryProgress';
import ImportReviewService from '../Service';
import { fetchImportDeltas, fetchImport } from '../../../../actions';

export class DeltaSummary extends Component {
  componentDidMount() {
    // Fetch import (if not in redux store)
    if (!this.props.import && this.props.botId && this.props.importId)
      fetchImport({ botId: this.props.botId, importId: this.props.importId });
  }

  approveAll() {
    return ImportReviewService.approveAll(this.props.botId, this.props.importId)
      .then(() => {
        // Fetch Deltas
        fetchImportDeltas({
          botId: this.props.botId,
          importId: this.props.importId,
        });
      })
      .catch(renderError);
  }

  rejectAll() {
    return ImportReviewService.rejectAll(this.props.botId, this.props.importId)
      .then(() => {
        // Fetch Deltas
        fetchImportDeltas({
          botId: this.props.botId,
          importId: this.props.importId,
        });
      })
      .catch(renderError);
  }

  confirm() {
    return ImportReviewService.confirm(this.props.botId, this.props.importId)
      .then(() => {
        // Navigate to answers page
        return GeckoLocation.goTo(`/bots/${this.props.botId}/answers`);
      })
      .catch(renderError);
  }

  cancel() {
    return ImportReviewService.cancel(this.props.botId, this.props.importId)
      .then(() => {
        // Navigate to answers page
        return GeckoLocation.goTo(`/bots/${this.props.botId}/answers`);
      })
      .catch(renderError);
  }

  isImportReviewPage() {
    return (
      this.props.location.page ===
      `/bots/${this.props.botId}/answers-import-review/${this.props.importId}`
    );
  }

  hasDeltasToReview() {
    return (
      this.props.import &&
      Number(
        (
          this.props.import.counts.find(
            (c) => c.review_status === CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED
          ) || {}
        ).count
      )
    );
  }

  renderActionBtns() {
    let btns = [];
    if (
      !this.isImportReviewPage() &&
      this.props.import.status !== CONSTS.IMPORT_STATUS_COMMITTED
    ) {
      btns = [
        {
          name: 'Continue Review',
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          handler: () =>
            GeckoLocation.goTo(
              `/bots/${this.props.botId}/answers-import-review/${this.props.importId}`
            ),
        },
      ];
    } else if (this.props.import.status === CONSTS.IMPORT_STATUS_REVIEW) {
      if (this.hasDeltasToReview()) {
        btns = [
          {
            name: 'Reject All Changes',
            icon: 'far fa-times',
            type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
            handler: this.rejectAll.bind(this),
          },
          {
            name: 'Approve All Changes',
            icon: 'far fa-check',
            type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
            handler: this.approveAll.bind(this),
          },
        ];
      } else {
        btns = [
          {
            name: 'Cancel Import',
            icon: 'far fa-times',
            type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
            handler: this.cancel.bind(this),
          },
          {
            name: 'Confirm Import',
            icon: 'far fa-check',
            type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
            handler: this.confirm.bind(this),
          },
        ];
      }
    }
    return <GeckoBtns items={btns} />;
  }

  render() {
    if (this.props.import) {
      return (
        <div className="DeltaSummary">
          <GeckoCard>
            <div className="DeltaSummary-content">
              <DeltaSummaryProgress importId={this.props.importId} />
              {this.renderActionBtns()}
            </div>
          </GeckoCard>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state, props) => {
  return {
    location: state.location,
    import: state.botsRoute.importsById[props.importId],
  };
};

export default connect(mapStateToProps)(DeltaSummary);
